import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CvaLoggerService } from "./services/cva-logger/cva-logger.service";
import { CVANotificationService } from "./services/cva-notification/cva-notification.service";
import { LoginService } from "./services/login/login.service";
import { SpinnerService } from './services/spinner/spinner.service';
import { Subject, takeUntil } from 'rxjs';
import { AeroCloudService } from './services/aero-cloud/aero-cloud.service';

@Component({
  selector: 'cva-standalone-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  spinnerMessage: string = 'Loading...';

  constructor(
    public cvaLogger: CvaLoggerService,
    public cvaNotificationService: CVANotificationService,
    public router: Router,
    public loginService: LoginService,
    public cdr: ChangeDetectorRef,
    private _elementRef: ElementRef,
    private spinnerService: SpinnerService,
    private aeroCloudService: AeroCloudService
  ) { }

  ngOnInit() {
    this._elementRef.nativeElement.removeAttribute("ng-version");
    this.spinnerService.message$
      .pipe(takeUntil(this.destroy$))
      .subscribe((message: string) => {
        this.spinnerMessage = message;
      });

    const context = sessionStorage.getItem('aeroCloudContext');
    const sessionKey = sessionStorage.getItem('session_key');
    const callBackUrl = sessionStorage.getItem('callback_url');
    const sessionId = sessionStorage.getItem('session_id');
    if(context && sessionKey && callBackUrl && sessionId) {
      this.aeroCloudService.context = JSON.parse(context);
      this.aeroCloudService.sessionKey = sessionKey;
      this.aeroCloudService.callBackUrl = callBackUrl;
      this.aeroCloudService.sessionId = sessionId;
    } else {
      // TODO: Redirect to error page;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
